import api from './api';

// Mirrors the server limits in qerchabackend/utils/sessionPolicy.js (the server is the real enforcer)
export const IDLE_MS_ADMIN = 15 * 60 * 1000;
export const IDLE_MS_USER = 30 * 60 * 1000;
export const WARN_MS = 2 * 60 * 1000;
const PING_MS = 60 * 1000;
const ADMIN_ROLES = ['superadmin', 'supplieradmin'];

export const idleLimitMs = (role) => (ADMIN_ROLES.includes(role) ? IDLE_MS_ADMIN : IDLE_MS_USER);

// Records a user interaction. Shared across tabs via localStorage; calls the server at most once a minute
// unless forced (the "Stay signed in" button).
export function recordActivity(force = false) {
  const now = Date.now();
  localStorage.setItem('lastActivity', String(now));
  if (force || now - Number(localStorage.getItem('lastPing') || 0) > PING_MS) {
    localStorage.setItem('lastPing', String(now));
    api.post('/api/users/session/activity').catch(() => {});
  }
}

// Clears all client-side auth state and cached user data
export function clearSession() {
  ['user', 'token', 'lastActivity', 'lastPing'].forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event('session-cleared')); // open views drop any private data they hold
}

// One-time notice for the login page; kept in sessionStorage so a refresh does not show it again
export const EXPIRY_NOTICE_KEY = 'sessionExpiryNotice';

// Clears state and sends the user to login with a one-time notice ('idle' or 'expired')
export function expireSession(reason) {
  clearSession();
  sessionStorage.setItem(EXPIRY_NOTICE_KEY, reason);
  window.location.href = '/login';
}
